/**
 * Share button for the store pages.
 *
 * Progressive enhancement: the button is rendered with the `hidden` class and
 * only revealed when the browser can actually do something with it, so nobody
 * gets a control that does nothing.
 *
 * Markup:
 *   <button data-versa-share data-share-title="Vapes Göteborg" class="hidden">Dela</button>
 */
( function () {
	'use strict';

	var canShare = 'function' === typeof navigator.share;
	var canCopy = !! ( navigator.clipboard && 'function' === typeof navigator.clipboard.writeText );

	function reveal() {
		var buttons = document.querySelectorAll( '[data-versa-share]' );
		for ( var i = 0; i < buttons.length; i++ ) {
			buttons[ i ].classList.remove( 'hidden' );
		}
	}

	function flash( button, message ) {
		var label = button.querySelector( '[data-share-label]' ) || button;
		var original = label.textContent;
		label.textContent = message;
		setTimeout( function () {
			label.textContent = original;
		}, 2000 );
	}

	function onClick( event ) {
		var button = event.target.closest( '[data-versa-share]' );
		if ( ! button ) {
			return;
		}
		event.preventDefault();

		var data = {
			title: button.getAttribute( 'data-share-title' ) || document.title,
			url: button.getAttribute( 'data-share-url' ) || window.location.href,
		};

		if ( canShare ) {
			// A dismissed share sheet rejects with AbortError — not an error
			// worth surfacing to the user.
			navigator.share( data ).catch( function () {} );
			return;
		}

		if ( canCopy ) {
			navigator.clipboard.writeText( data.url ).then( function () {
				flash( button, 'Länk kopierad' );
			} ).catch( function () {} );
		}
	}

	if ( canShare || canCopy ) {
		document.addEventListener( 'click', onClick );

		if ( 'loading' === document.readyState ) {
			document.addEventListener( 'DOMContentLoaded', reveal );
		} else {
			reveal();
		}
	}
} )();
